var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-avatar',{class:'col ' + _vm.active,staticStyle:{"background-color":"#C0C4CC"},attrs:{"fit":"scale-down","shape":"square","size":_vm.size,"src":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }